module.exports = __webpack_public_path__ + "static/media/RiskBanner.8a5e9b16.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/RiskBanner.png
// module id = 1710
// module chunks = 0 1